import { map, filter, withLatestFrom, switchMap, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { OrganisationsApi } from '@careapp/angular-sdk';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import * as actions from '../actions/index';
import * as selectors from '../reducers/index';
import { environment } from '../../../environments/environment';

export const dashboardRegex = /^\/organisations\/[a-z0-9-]+$/;

@Injectable()
export class StatisticsEffects {
  @Effect()
  getCustomersStatistics = this.actions$.ofType(actions.REQUEST_CUSTOMERS_STATISTICS).pipe(
    withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))),
    switchMap(([action, orgId]) => {
      return this.api
        .getCustomerActivity(orgId, (<any>action).payload)
        .map(stats => new actions.ResponseSuccessCustomersStatisticsAction(stats));
    })
  );

  @Effect({ dispatch: false })
  fetchRelatedCustomers = this.actions$.ofType(actions.RESPONSE_SUCCESS_CUSTOMERS_STATISTICS).pipe(
    tap(action => {
      (<any>action).payload.map(stat => {
        this.store.dispatch(actions.Customers.RequestByIdAction({ id: stat.customerId }));
      });
    })
  );

  @Effect()
  getMemoStatistics = this.actions$.ofType(actions.REQUEST_MEMO_STATISTICS).pipe(
    withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))),
    switchMap(([action, orgId]) => {
      return this.api
        .memoStats(orgId)
        .map(stats => new actions.ResponseSuccessMemoStatisticsAction(stats));
    })
  );

  @Effect()
  getMembersStatistics = this.actions$.ofType(actions.REQUEST_MEMBERS_STATISTICS).pipe(
    withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))),
    switchMap(([action, orgId]) => {
      return this.api
        .getMemberActivity(orgId, (<any>action).payload)
        .map(stats => new actions.ResponseSuccessMembersStatisticsAction(stats));
    })
  );

  @Effect({ dispatch: false })
  fetchRelatedMembers = this.actions$.ofType(actions.RESPONSE_SUCCESS_MEMBERS_STATISTICS).pipe(
    tap(action => {
      (<any>action).payload.map(stat => {
        this.store.dispatch(actions.Staff.RequestByIdAction({ id: stat.memberId }));
      });
    })
  );

  @Effect({ dispatch: false })
  refreshStatistics = this.actions$.ofType(actions.Organisations.SELECT_BY_ID).pipe(
    withLatestFrom(this.store.select(selectors.getRouterState)),
    filter(
      ([action, router]) => (router && router.state ? dashboardRegex.test(router.state.url) : false)
    ),
    tap(action => {
      this.store.dispatch(
        new actions.RequestCustomersStatisticsAction({ limit: environment.STATS_TABLE_LIMIT })
      );
      this.store.dispatch(new actions.RequestMemoStatisticsAction());
      this.store.dispatch(
        new actions.RequestMembersStatisticsAction({ limit: environment.STATS_TABLE_LIMIT })
      );
      this.store.dispatch(actions.MemoCategories.RequestAllAction);
      this.store.dispatch(actions.CheckIns.RequestAllAction);
    })
  );

  constructor(
    private actions$: Actions,
    private api: OrganisationsApi,
    private store: Store<any>
  ) {}
}
